/**
 * Groups for the smoke runner checklist. Read-only stays one bucket;
 * write scenarios are split so "Include writes" is not a flat dump of 15 rows.
 */

export const SMOKE_GROUPS = [
  {
    id: 'read',
    label: 'Read-only',
    write: false,
    description: 'Auth, settings, list access, and the client role-contract matrix.'
  },
  {
    id: 'probes',
    label: 'Core probes',
    write: true,
    description: 'Allowed and forbidden writes against the live rules for this JWT.'
  },
  {
    id: 'students',
    label: 'Students',
    write: true,
    description: 'Student lifecycle, the Other plan, edit scope, contacts, and document storage.'
  },
  {
    id: 'imports',
    label: 'Student imports',
    write: true,
    description:
      '504 import, saved outcomes and Undo on disposable campuses; manual UI checklist below.'
  },
  {
    id: 'district',
    label: 'District roles',
    write: true,
    description:
      'District Admin, Coordinator and all three district case-manager profiles across two campuses.'
  },
  {
    id: 'staff',
    label: 'Staff',
    write: true,
    description: 'User document create / read / update / delete.'
  },
  {
    id: 'feedback',
    label: 'Feedback',
    write: true,
    description: 'Templates, the completed-vs-closed lock, and view-only sharing.'
  },
  {
    id: 'evaluations',
    label: 'Evaluations',
    write: true,
    description:
      'Evaluation records, referral access, CM mirror, card lifecycle, fillable shell, and outcome apply.'
  },
  {
    id: 'meetings',
    label: 'Meetings',
    write: true,
    description: 'reconcileMeetings, meeting documents, campus defaults, and gen-ed hours.'
  },
  {
    id: 'schoolOps',
    label: 'School operations',
    write: true,
    description: 'Extended access, aide schedules, email config, schools, and reference docs.'
  },
  {
    id: 'testing',
    label: 'Testing',
    write: true,
    description: 'Accommodations mirror, attendance, session notes, and the testing calendar.'
  },
  {
    id: 'adminAudit',
    label: 'Admin & audit',
    write: true,
    description: 'Backups, issue reports, and PDF metadata / access logs.'
  }
]

export const SCENARIO_GROUP_BY_ID = {
  authBootstrap: 'read',
  appSettings: 'read',
  readAccess: 'read',
  roleContractMatrix: 'read',
  permissionProbes: 'probes',
  importWorkflow: 'imports',
  districtAccess: 'district',
  studentsCrud: 'students',
  otherPlan: 'students',
  studentEditScope: 'students',
  documentsAccess: 'students',
  studentPrivate: 'students',
  encryptedPdfs: 'students',
  usersCrud: 'staff',
  feedbackTemplateCrud: 'feedback',
  feedbackCloseLock: 'feedback',
  feedbackViewerShare: 'feedback',
  studentEvaluationCrud: 'evaluations',
  evalCaseManagerMirror: 'evaluations',
  evalCardLifecycle: 'evaluations',
  evalFillableShell: 'evaluations',
  referralAccess: 'evaluations',
  evalOutcomeApply: 'evaluations',
  meetingReconcileGate: 'meetings',
  meetingsCrud: 'meetings',
  meetingDefaults: 'meetings',
  genEdHours: 'meetings',
  extendedAccess: 'schoolOps',
  aideSchedules: 'schoolOps',
  emailConfig: 'schoolOps',
  schoolsTenancy: 'schoolOps',
  refDocuments: 'schoolOps',
  testingModule: 'testing',
  adminFerpa: 'adminAudit',
  saleReadiness: 'adminAudit'
}

export function groupIdForScenario(scenario) {
  if (SCENARIO_GROUP_BY_ID[scenario.id]) return SCENARIO_GROUP_BY_ID[scenario.id]
  return scenario.destructive ? 'probes' : 'read'
}

export function scenariosByGroup(allScenarios = []) {
  return SMOKE_GROUPS.map((group) => ({
    ...group,
    scenarios: allScenarios.filter((s) => groupIdForScenario(s) === group.id)
  })).filter((group) => group.scenarios.length > 0)
}

export function groupSelectionState(group, selectedIds = []) {
  const ids = group.scenarios.map((s) => s.id)
  const n = ids.filter((id) => selectedIds.includes(id)).length
  return {
    all: ids.length > 0 && n === ids.length,
    some: n > 0 && n < ids.length,
    none: n === 0
  }
}
